var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Toast } from '../Toast';
import { Account } from '../Account';
export class List extends Component {
    constructor() {
        super('List', true);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            List.status = 'empty';
            $('.btn-open-list').on('click', (event, button) => {
                event.preventDefault();
                $('.aside-panel').addClass('d-none');
                $('#list').removeClass('d-none');
            });
            $('.btn-list-add').on('click', (event, button) => {
                event.preventDefault();
                let newProduct = JSON.parse(atob(button.data('productData')));
                let isAlreadyInProducts = false;
                List.products.forEach((product) => {
                    if (product.id == newProduct.id)
                        isAlreadyInProducts = true;
                });
                let message = '';
                if (!isAlreadyInProducts) {
                    List.products.push(newProduct);
                    message = ($('html').attr('lang') == 'fr_FR') ? 'Le produit a été ajouté votre liste' : 'Product has been added to your list';
                }
                else {
                    message = ($('html').attr('lang') == 'fr_FR') ? 'Ce produit se trouve déjà dans votre liste' : 'This product is already in your list';
                }
                Toast.show(message);
                List.status = 'unsaved';
                List.save();
                List.update();
            });
            $('body').on('click', '.btn-remove-product', (event, button) => {
                event.preventDefault();
                List.removeProduct(parseInt(button.data('id')));
            });
            $('#btn-new-list').on('click', (event) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                let doNew = true;
                if (List.status == 'unsaved')
                    doNew = confirm($('html').attr('lang') == 'fr_FR' ? 'Votre liste actuelle n\'a pas été sauvegardé. Êtes-vous certain de vouloir l\'effacer' : 'Your current list has not been saved. Are you sure you want to clear it?');
                if (doNew) {
                    List.load(null, null, null, null);
                }
            }));
            $('#btn-save-list').on('click', (event) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                if (!$('body').hasClass('logged-in')) {
                    const loginMessage = $('html').attr('lang') == 'fr_FR' ? 'Afin de sauvegarder votre liste, vous devez vous connecter ou créer un compte.' : 'To save your list, you must first login or create an account.';
                    Toast.show(loginMessage);
                    return;
                }
                const newTitle = $('#list-title').val();
                if (newTitle == '') {
                    alert($('html').attr('lang') == 'fr_FR' ? 'Le titre de votre liste ne peux pas être vide.' : 'The title of the list cannot be empty.');
                    $('#list-title').get(0).focus();
                    return;
                }
                $('#btn-save-list, #btn-new-list, #btn-request-quote').addClass('loading');
                let newId = yield $.httpRequest({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    body: {
                        'action': 'save_list',
                        'id': List.id,
                        'title': newTitle,
                        'products': JSON.stringify(List.products)
                    },
                    dataType: 'json',
                });
                $('#btn-save-list, #btn-new-list, #btn-request-quote').removeClass('loading');
                List.status = 'saved';
                const toastMessage = ($('html').attr('lang') == 'fr_FR') ? 'Votre liste a été sauvegardée avec succès' : 'Your list has been saved successfuly';
                Toast.show(toastMessage);
                List.updateTitle(List.title, newId);
                List.save();
                List.update();
                Account.refresh();
            }));
            $('#btn-request-quote').on('click', (event) => {
                event.preventDefault();
                $('#list .spacer').removeClass('offset-lg-22 offset-xl-26');
                $('#form-request-quote').addClass('opened');
                $('#btn-request-quote').addClass('d-none');
            });
            if ($('.gform_validation_errors').length > 0 || $('.gform_confirmation_message').length > 0) {
                $('aside').addClass('opened');
                $('#aside-backdrop').addClass('active');
                $('.aside-panel').addClass('d-none');
                $('#list').removeClass('d-none');
                $('#list .spacer').removeClass('offset-lg-22 offset-xl-26');
                $('#form-request-quote').addClass('opened');
                $('#btn-request-quote').addClass('d-none');
            }
            List.load(sessionStorage.getItem('list_id'), sessionStorage.getItem('list_title'), sessionStorage.getItem('list_status'), sessionStorage.getItem('list_products'));
            this.success();
        });
    }
    static load(id, title, status, rawData) {
        List.id = id;
        List.title = title;
        List.status = status;
        List.products = JSON.parse(rawData);
        if (!List.id)
            List.id = '0';
        if (!List.title)
            List.title = $('html').attr('lang') == 'fr_FR' ? 'Ma liste' : 'My list';
        if (!List.products)
            List.products = [];
        if (!List.status)
            List.status = List.products.length > 0 ? 'unsaved' : 'empty';
        console.log(List.status);
        List.updateTitle();
        List.update();
        List.save();
    }
    static update() {
        if (List.products.length > 0) {
            $('#list-empty').addClass('d-none');
            $('#btn-save-list, #btn-new-list, #btn-request-quote').removeClass('disabled');
        }
        else {
            $('#list-empty').removeClass('d-none');
            $('#btn-save-list, #btn-new-list, #btn-request-quote').addClass('disabled');
            List.status = 'empty';
            this.updateTitle($('html').attr('lang') == 'fr_FR' ? 'Ma liste' : 'My list', '0');
        }
        $('#list .product:not(.product-reference)').remove();
        let listText = '';
        List.products.forEach((product) => {
            let newProductElement = $('.product-reference').clone();
            newProductElement.removeClass('product-reference');
            newProductElement.find('.btn-remove-product').attr('data-id', product.id);
            newProductElement.find('.title .link').text(product.title);
            newProductElement.find('.thumbnail').css('background-image', 'url(\'' + product.thumbnail + '\')');
            newProductElement.find('.link').attr('href', product.link);
            $('#list .products').append(newProductElement);
            listText += product.title + '\n';
        });
        $('#input_1_12, #input_2_12').text(listText);
        $('.list-count').text(List.products.length);
        List.updateTitle();
    }
    static removeProduct(id) {
        List.products.forEach((product, index) => {
            if (product.id == id) {
                List.products.splice(index, 1);
            }
        });
        List.status = 'unsaved';
        List.save();
        List.update();
    }
    static save() {
        sessionStorage.setItem('list_id', List.id);
        sessionStorage.setItem('list_title', List.title);
        sessionStorage.setItem('list_products', JSON.stringify(List.products));
        sessionStorage.setItem('list_status', List.status);
    }
    static updateTitle(title, id) {
        if (title)
            List.title = title;
        if (id)
            List.id = id;
        $('#list-title').val(List.title).data('id', List.id);
        let buttonTitle = $('html').attr('lang') == 'fr_FR' ? 'Enregistrer' : 'Save';
        /*if (List.id != '0') {
          buttonTitle = $('html').attr('lang') == 'fr_FR' ? 'Mettre à jour' : 'Update';
        }*/
        $('#btn-save-list .txt').text(buttonTitle);
    }
}
